import { actions } from "../actions";
import { ListingSearchResult, HotelDetailsEntrySourceEnum, LodgingPrice } from "redmond";
import {
  SELECT_HOME,
  SET_SELECTED_LISTING_ID,
  FETCH_VACATION_RENTAL_SHOP,
  SET_VACATION_RENTAL_SHOP_CALL_STATE_FAILED,
  SET_NOTIFY_IF_SHOP_AND_BOOK_PRICE_DIFFER_FLAG,
  SET_LISTING_CALENDAR,
  SET_VACATION_RENTAL_ENTRY_SOURCE,
  SET_VACATION_RENTAL_ENTRY_POINT,
  SET_VACATION_RENTAL_SORT_ORDER,
  SET_SELECTED_HOME_IS_FAVORITED,
  SET_LIST_PRICE,
} from "../actions/constants";
import {
  ListingId,
  VacationRentalCalendarResponse,
} from "redmond/apis/tysons/vacation-rentals";
export interface IVacationRentalShopState {
  selectedHome: ListingSearchResult | null;
  selectedHomeCalendar?: VacationRentalCalendarResponse;
  selectedHomeIsFavorited?: boolean;
  vacationRentalListingId: ListingId | null;
  vacationRentalShopCallState: VacationRentalShopCallState;
  vacationRentalShopCallError?: VacationRentalShopCallError;
  vacationRentalNotifyIfShopAndBookPriceDiffer: boolean;
  vacationRentalDetailsEntrySource?: HotelDetailsEntrySourceEnum;
  vacationRentalEntryPoint?: string;
  vacationRentalSortOrder?: string;
  listPrice: LodgingPrice | null | undefined;
}

export enum VacationRentalShopCallState {
  NotCalled = "NotCalled",
  InProcess = "InProcess",
  Success = "Success",
  Failed = "Failed",
  FailureAcknowledged = "FailureAcknowledged",
}

export enum VacationRentalShopCallError {
  NoAvailability = "NoAvailability",
  Unknown = "Unknown",
}

const initialState: IVacationRentalShopState = {
  selectedHome: null,
  vacationRentalListingId: null,
  vacationRentalShopCallState: VacationRentalShopCallState.NotCalled,
  vacationRentalShopCallError: undefined,
  vacationRentalNotifyIfShopAndBookPriceDiffer: true,
  vacationRentalDetailsEntrySource: undefined,
  vacationRentalEntryPoint: undefined,
  vacationRentalSortOrder: undefined,
  selectedHomeIsFavorited: undefined,
  listPrice: undefined,
};

export const reducer = (
  state: IVacationRentalShopState = initialState,
  action: actions.VacationRentalShopActions
): IVacationRentalShopState => {
  switch (action.type) {
    case FETCH_VACATION_RENTAL_SHOP:
      return {
        ...state,
        vacationRentalShopCallState: VacationRentalShopCallState.InProcess,
        listPrice: undefined,
      };
    case SELECT_HOME:
      return {
        ...state,
        selectedHome: action.home,
        vacationRentalShopCallState: VacationRentalShopCallState.Success,
      };
    case SET_LISTING_CALENDAR:
      return {
        ...state,
        selectedHomeCalendar: action.calendar,
      };
    case SET_SELECTED_LISTING_ID:
      return {
        ...state,
        vacationRentalListingId: action.id,
      };
    case SET_VACATION_RENTAL_SHOP_CALL_STATE_FAILED:
      return {
        ...state,
        vacationRentalShopCallState: VacationRentalShopCallState.Failed,
        vacationRentalShopCallError: action.vrShopCallError,
        listPrice: state.listPrice ?? null,
      };
    case SET_NOTIFY_IF_SHOP_AND_BOOK_PRICE_DIFFER_FLAG:
      return {
        ...state,
        vacationRentalNotifyIfShopAndBookPriceDiffer: action.notify,
      };
    case SET_VACATION_RENTAL_ENTRY_SOURCE:
      return {
        ...state,
        vacationRentalDetailsEntrySource: action.entrySource,
      };
    case SET_VACATION_RENTAL_ENTRY_POINT:
      return {
        ...state,
        vacationRentalEntryPoint: action.entryPoint,
      };
    case SET_VACATION_RENTAL_SORT_ORDER:
      return {
        ...state,
        vacationRentalSortOrder: action.sortOrder,
      };
    case SET_SELECTED_HOME_IS_FAVORITED:
      return {
        ...state,
        selectedHomeIsFavorited: action.isFavorited,
      };
    case SET_LIST_PRICE:
      return {
        ...state,
        listPrice: action.listPrice,
      };
    default:
      return { ...state };
  }
};

export * from "./selectors";
